import { Typography, useTheme } from '@mui/material';
import { ResponsiveStyleValue } from '@mui/system';
import SupText from 'components/SupText';
import { Property } from 'csstype';
import color from 'themes/color';

function NumberSupSymbol(props: {
    content: string | number;
    symbol: string;
    colorText?: string;
    fw?: number;
    variant?:
        | 'button'
        | 'caption'
        | 'h1'
        | 'h2'
        | 'h3'
        | 'h4'
        | 'h5'
        | 'h6'
        | 'inherit'
        | 'subtitle1'
        | 'subtitle2'
        | 'body1'
        | 'body2'
        | 'overline';
    fs?: string;
    display?: boolean;
    colorSupText?: string;
    fsMainText?: string;
    fwSupText?: number;
    textAlign?: ResponsiveStyleValue<Property.TextAlign | NonNullable<Property.TextAlign | undefined>[] | undefined>;
}) {
    const theme = useTheme();
    const {
        content,
        symbol,
        colorText = color.red,
        fw = 500,
        variant = 'h6',
        fs = '0.65rem',
        display = true,
        colorSupText = theme.palette.primary.dark,
        fsMainText,
        fwSupText,
        textAlign
    } = props;
    return (
        <Typography
            variant={variant}
            color={colorText}
            sx={{ display: 'inline', wordBreak: 'break-all !important' }}
            fontWeight={fw}
            fontSize={fsMainText}
            textAlign={textAlign}
        >
            {display ? content : '********'} {display && <SupText colorText={colorSupText} symbol={symbol} fs={fs} fw={fwSupText} />}
        </Typography>
    );
}

export default NumberSupSymbol;
